module.exports = __webpack_public_path__ + "static/media/bath-1.c306d93f.png";